export default "__VITE_ASSET__C_Xt4Mbv__"